import i18n from './i18n'

const existKeyLocal = (key: string): boolean => i18n.exists(key)

export default existKeyLocal
